import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import permissions from "app/permissions";
import { NACID_FLOWS, NacidServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import NacidFlowList from "./List";
import NacidFlowShow from "./Show/Show";

// No create/edit: flows are produced by NacidService from student events, never authored here. The only writes
// are the sub-resource actions on the Show page.
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <SyncProblemIcon />,
  name: NacidServicePath + NACID_FLOWS,
  title: "НАЦИД потоци",
  list: <NacidFlowList />,
  show: <NacidFlowShow />,
  permission: permissions.canPreviewNacidFlows,
  showPermission: permissions.canPreviewNacidFlows,
};
